import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getEmailAddressActivationStatus } from '../../user/user-actions';
import { useUser } from '../../user/useUser';
import { facebookIsOnlyLoginOption } from '../../user/user-model';

export const useIsUserEmailActivated = () => {
    const dispatch = useDispatch();
    const user = useUser();
    const [initialActivationStatus] = useState(user?.activated);
    const timesChecked = useRef(0);
    const timeoutInterval = useRef(2000);
    const activationStatusInterval = useRef(1);
    const shouldChangeInterval = timesChecked.current % 20 === 0 && timeoutInterval.current < 20_000;
    const canContinueToActivateFacebook = facebookIsOnlyLoginOption(user) && !!user?.canContinueToActivateUser;

    const checkStatusOnInterval = () => {
        clearInterval(activationStatusInterval.current);
        if (user?.id && !user.activated && !canContinueToActivateFacebook) {
            activationStatusInterval.current = setInterval(() => {
                timesChecked.current = timesChecked.current + 1;
                dispatch(getEmailAddressActivationStatus());
            }, timeoutInterval.current);
        }
    };

    useEffect(() => {
        checkStatusOnInterval();

        return () => clearInterval(activationStatusInterval.current);
    }, []);

    useEffect(() => {
        if (shouldChangeInterval) {
            timeoutInterval.current = timeoutInterval.current * 2;
            checkStatusOnInterval();
        }
    }, [shouldChangeInterval]);

    useEffect(() => {
        if (user?.activated && !initialActivationStatus) {
            clearInterval(activationStatusInterval.current);
        }
    }, [user?.activated, activationStatusInterval.current, initialActivationStatus]);

    return { initialActivationStatus, isUserActivated: user?.activated, canContinueToActivateFacebook };
};
